import { useEffect, useRef, useSyncExternalStore } from 'react'
import { useShellActions, type PaletteAction } from '@pilot-hub/ui'

/*
 * Modul-lokale Aktionsliste: Aktionen erscheinen in der Befehlspalette (Strg+K, über useShellActions)
 * UND im Schnellaktionen-Sheet am Tablet (PhasenSteuerung). packages/ui bleibt unberührt.
 */
type Eintrag = { key: number; aktionen: PaletteAction[] }
let eintraege: Eintrag[] = []
let zaehler = 0
let schnappschuss: PaletteAction[] = []
const hoerer = new Set<() => void>()
const melden = () => { schnappschuss = eintraege.flatMap(e => e.aktionen); hoerer.forEach(h => h()) }

export function useSchnellAktionenListe(): PaletteAction[] {
  return useSyncExternalStore(h => { hoerer.add(h); return () => { hoerer.delete(h) } }, () => schnappschuss)
}

/** Registriert Aktionen in Befehlspalette und Schnellaktionen-Sheet, solange die Komponente eingehängt ist. */
export function useFuehrungAktionen(aktionen: PaletteAction[], deps: React.DependencyList = []) {
  useShellActions(aktionen, deps)
  const ref = useRef(aktionen)
  ref.current = aktionen
  useEffect(() => {
    const key = ++zaehler
    const proxies = ref.current.map((a, i) => ({ ...a, run: () => ref.current[i]?.run() }))
    eintraege = [...eintraege, { key, aktionen: proxies }]
    melden()
    return () => { eintraege = eintraege.filter(e => e.key !== key); melden() }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)
}
